const objectManager = {
  key: "object-manager",
  title: "Object Manager",
  fullWidthGanttBars: true,
  angle: -10,
  summary:
    "Structure model objects for faster retrieval and cleaner governance.",
  releaseDate: "Continuously maintained",
  launch: "/",
  planStages: [
    {
      name: "Scoping documents",
      detail: [
        {
          text: "Concept feature",
          checked: true,
        },
        {
          text: "Business Systems Requirements Document (BSRD)",
          checked: true,
        },
        {
          text: "Functional Design Document (FDD)",
          checked: true,
        },
      ],
      completionDate: "Aug 26",
    },
    {
      name: "Development",
      detail: [
        {
          text: "Admin feature development & testing",
          checked: true,
        },
        {
          text: "Main feature development",
          checked: true,
        },
        {
          text: "Data entry (this is ongoing and will continue after initial release)",
          checked: false,
        },
        {
          text: "Development phase testing",
          checked: false,
        },
      ],
      completionDate: "Oct 26",
    },
    {
      name: "Testing & QA",
      detail: [
        {
          text: "Workflow documents production",
          checked: false,
        },
        {
          text: "Main feature testing",
          checked: false,
        },
        {
          text: "Training & support documentation production",
          checked: false,
        },
        {
          text: "Training and deployment",
          checked: false,
        },
      ],
      completionDate: "Dec 26",
    },
  ],
  points: [
    "Full library of standard objects (pumps, valves, instruments, etc.)",
    "Admin area to manage object types and properties",
    "Facilitates intelligent 3D-models and P&ID's",
    "Facilitates automated information production (schedules, data sheets, etc.)",
  ],
};

export default objectManager;
